import { useRouter } from 'next/router'
import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { adaptFetcherToSWRMutationFn } from 'shared/api/utils/adapt-fetcher-to-swr-mutation'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'

interface UsePublishPostsMultipleOptions {
  config?: SWRMutationConfiguration<void, Error, string, PublishPostsMultipleRequestBody, void>
}

interface PublishPostsMultipleRequestBody {
  ids: number[]
}

export const usePublishPostsMultiple = ({ config }: UsePublishPostsMultipleOptions = {}) => {
  const router = useRouter()
  const { communityPath } = router.query as { communityPath?: string }

  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.post,
    void,
    PublishPostsMultipleRequestBody
  >({
    method: RequestMethodsEnum.post,
    badRequestHandler: () => {},
  })

  return useSWRMutation(
    communityPath
      ? `${COMMUNITY_API_PREFIX}/${communityPath}/moderation/posts/publish-multiple`
      : null,
    adaptFetcherToSWRMutationFn<void, PublishPostsMultipleRequestBody>(fetcher),
    config,
  )
}
